import 'css-chunksrc/client/common/resourceAllocationMenu/resourceGroups/styles.scss';export default {
  "groups": "_groups_znsja_1",
  "row": "_row_znsja_5",
  "header": "_header_znsja_15",
  "avatar": "_avatar_znsja_24",
  "iconBox": "_iconBox_znsja_31",
  "icon": "_icon_znsja_31",
  "title": "_title_znsja_47",
  "name": "_name_znsja_54",
  "list": "_list_znsja_61"
};